// extracted by mini-css-extract-plugin
export default {"instrumentCategory":"instrumentCategory-Zg05M"};